module.exports = __webpack_public_path__ + "img/banner-2-en-mobile.f08c3539.png";